var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-market-page" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("h1", [
            _vm._v(_vm._s(_vm.$t("chatbotv2.blockMarket") || "Block Market")),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus", size: "large" },
              on: { click: _vm.navigateToCreateBlock },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("chatbotv2.createNewBlock") || "Create New Block"
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-tabs",
        {
          staticClass: "market-tabs",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "a-tab-pane",
            {
              key: "marketplace",
              attrs: { tab: _vm.$t("chatbotv2.marketplace") || "Marketplace" },
            },
            [
              _c("BlockMarketplace", {
                on: { "view-details": _vm.viewBlockDetails },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "my-blocks",
              attrs: { tab: _vm.$t("chatbotv2.myBlocks") || "My Blocks" },
            },
            [
              _c("MyBlocks", {
                on: {
                  "edit-block": _vm.editBlock,
                  "view-details": _vm.viewBlockDetails,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "imported",
              attrs: {
                tab: _vm.$t("chatbotv2.importedBlocks") || "Imported Blocks",
              },
            },
            [
              _c("ImportedBlocks", {
                on: { "view-details": _vm.viewBlockDetails },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAdminSite
            ? _c(
                "a-tab-pane",
                {
                  key: "pending",
                  attrs: {
                    tab:
                      _vm.$t("chatbotv2.pendingApproval") || "Pending Approval",
                  },
                },
                [
                  _c("PendingApproval", {
                    on: { "view-details": _vm.viewBlockDetails },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDetailsModal
        ? _c("BlockDetailsModal", {
            attrs: { "block-id": _vm.selectedBlockId },
            on: { close: _vm.closeDetailsModal, import: _vm.handleImport },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }